import { getRailsClient } from "../../client";

export const getLastBanner = async () => {
  try {
    const API = "/api/internal_api/v1/admin/custom_notifications/show_last";
    const { data } = await getRailsClient().get(API);
    return data;
  } catch (error) {
    console.error("Error fetching last custom notifications:", error);
  }
};

export const createBanner = async ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  try {
    const API = "/api/internal_api/v1/admin/custom_notifications";
    const { data } = await getRailsClient().post(API, { title, description });
    return data;
  } catch (error) {
    console.error("Error creating custom banner:", error);
  }
};

export const destroyBanner = async () => {
  try {
    const API = "/api/internal_api/v1/admin/custom_notifications/destroy_all";
    await getRailsClient().delete(API);
  } catch (error) {
    console.error("Error deleting custom banners:", error);
  }
};
